export default [
    {
        "id": 0,
        "img": require("@/assets/cards/imgyongzjq-1.png"),
        "title": "勇者节",
        "tips": "薪火相聚，与你同行！勇者节，是属于全体勇者的节日！",
    },
    {
        "id": 1,
        "img": require("@/assets/cards/imgyongzjq-2.png"),
        "title": "喜迎新春",
        "tips": "春节将至，新朋旧友欢聚一堂，勇者城也热闹起来了！",
    },
    {
        "id": 2,
        "img": require("@/assets/cards/imgyongzjq-3.png"),
        "title": "雪日欢歌",
        "tips": "被白雪覆盖的勇者城另有一番风情，仿佛美丽而梦幻的童话世界！",
    },
    {
        "id": 3,
        "img": require("@/assets/cards/imgyongzjq-4.png"),
        "title": "除夕巡游",
        "tips": "除夕夜，安朵斯、帕尔、佛拉丝与勇者共游勇者城！",
    },
    {
        "id": 4,
        "img": require("@/assets/cards/imgjiebtx-1.png"),
        "title": "牛头人战士",
        "tips": "屠龙宝刀，点击就送；<br>极品装备，1秒刷爆！",
    },
    {
        "id": 5,
        "img": require("@/assets/cards/imgjiebtx-2.png"),
        "title": "中秋团圆",
        "tips": "勇者城首次中秋节活动，阿兔为嫦娥带盐，发月饼送好礼！",
    },
    {
        "id": 6,
        "img": require("@/assets/cards/imgjiebtx-3.png"),
        "title": "勇者小屋",
        "tips": "魔女们首次一起在勇者小屋聚会！",
    },
    {
        "id": 7,
        "img": require("@/assets/cards/imgjiebtx-4.png"),
        "title": "休憩时光",
        "tips": "勇者们围坐夜谈，享受难得的休憩时光。",
    },
    {
        "id": 8,
        "img": require("@/assets/cards/imgmaoxzt-1.png"),
        "title": "星界远征",
        "tips": "星界远征，是勇者们主动对未知领域的探索行动。",
    },
    {
        "id": 9,
        "img": require("@/assets/cards/imgmaoxzt-2.png"),
        "title": "挺进樱花岛",
        "tips": "樱花岛，是勇者们在星界远征中的第一站。",
    },
    {
        "id": 10,
        "img": require("@/assets/cards/imgmaoxzt-3.png"),
        "title": "斯托拉斯",
        "tips": "首位与勇者们发生冲突的魔女，她的大镰刀可不是能用来开玩笑的。",
    },
    {
        "id": 11,
        "img": require("@/assets/cards/imgmaoxzt-4.png"),
        "title": "秘境探索",
        "tips": "临夜，秘境之门再度开启，冒险将至，无限可能！",
    },
    {
        "id": 12,
        "img": require("@/assets/cards/img4zhounq-1.png"),
        "title": "4周年送560抽",
        "tips": "勇者城4周年盛典开启！周年庆期间最高可领560连抽！带上新老朋友，一起来玩吧~",
    },
    {
        "id": 13,
        "img": require("@/assets/cards/img4zhounq-2.png"),
        "title": "魔女集结",
        "tips": "四载相伴，感谢有你，我们在勇者城等你一起冒险再出发！",
    },
    {
        "id": 14,
        "img": require("@/assets/cards/img4zhounq-3.png"),
        "title": "龙虎之力",
        "tips": "虎啸天魂住，龙吟地魄来。嘉波同时具备“龙与虎”两种神兽之力，散发出神秘而强大的气场。",
    },
    {
        "id": 15,
        "img": require("@/assets/cards/img4zhounq-4.png"),
        "title": "神拳·嘉波",
        "tips": "嘉波精通武术、气功，行踪神秘莫测，常出没于山林要道，与路过的武者切磋。",
    },
]